import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

import { EditQuoteTermState } from "@tKgpco/Store/Data/Terms/TermsState";

const initialState: EditQuoteTermState = {
    isLoading: false,
    quoteTerm: null as any,
};
export const reducer = {
    "Custom/EditTerms/BeginLoad": (draft: Draft<EditQuoteTermState>) => {
        draft.isLoading = true;
    },
    "Custom/EditTerms/CompleteLoad": (draft: Draft<EditQuoteTermState>, action: EditQuoteTermState) => {
        draft.isLoading = false;
        draft.quoteTerm = action.quoteTerm;
    },
    "Custom/EditTerms/FailedToLoadTerms": (draft: Draft<EditQuoteTermState>) => {
        draft.isLoading = false;
        draft.quoteTerm = null as any;
    },
};
export default createTypedReducerWithImmer(initialState, reducer);
